import { useI18n } from 'modules/i18n';
import { usePathBase } from 'modules/routes';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export function Messages({ loggedInAt, notifications }) {
    const { t } = useI18n();
    const pathBase = usePathBase();

    if (loggedInAt + 5000 > Date.now()) {
        return (
            <p className="messages">{t('devise.omniauth_callbacks.success')}</p>
        );
    } else if (notifications.length > 0) {
        return (
            <div className="notifications">
                {notifications.map((notification, index) => {
                    return (
                        <p key={`notification-${index}`}>
                            {t(notification.title, {
                                file: notification.locale,
                                archiveId: notification.archive_id,
                            })}
                            <Link
                                to={
                                    pathBase +
                                    '/interviews/' +
                                    notification.archive_id
                                }
                            >
                                {notification.archive_id}
                            </Link>
                        </p>
                    );
                })}
            </div>
        );
    } else {
        return null;
    }
}

Messages.propTypes = {
    loggedInAt: PropTypes.number,
    notifications: PropTypes.array.isRequired,
};

export default Messages;
